import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-corporate-events',
  templateUrl: './corporate-events.component.html',
  styleUrls: ['./corporate-events.component.css']
})
export class CorporateEventsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
